import { Component, JSXElement, Match, Show, Switch } from "solid-js";

import { UserRoleType } from "../../schema/graphql.js";
import { useAuth } from "../auth/AuthContext.js";
import { useAdminAgencyContext } from "../candidates/AdminAgencyContext.js";
import Select from "../form/Select.js";

export const AgencySelector: Component<{
  label?: boolean | JSXElement | string;
  onChange?: (agencyId: number | null) => void;
  class?: string;
  containerClass?: string;
}> = (props) => {
  const auth = useAuth();
  const adminAgency = useAdminAgencyContext();

  const agencyChanged = (agencyId: number | null) => {
    adminAgency?.setCurrentAgency(agencyId);
    props.onChange?.(agencyId);
  };

  const getAgencyOptions = () => {
    const agencyOptions =
      adminAgency
        ?.agencies()
        .map((agency) => ({
          value: agency.id,
          name: agency.name,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)) ?? [];
    return [
      { value: null, name: "-- No agency selected --" },
      ...agencyOptions,
    ];
  };

  return (
    <Show when={auth?.authenticatedUser()?.role === UserRoleType.Admin}>
      <div class={`flex items-center gap-2 ${props.containerClass ?? ""}`}>
        <Switch>
          <Match when={props.label}>{props.label}</Match>
          <Match when={props.label === undefined || props.label === null}>
            <span class="whitespace-nowrap">View as</span>
          </Match>
        </Switch>
        <Select
          onChange={agencyChanged}
          value={adminAgency?.agencyId() as any}
          options={getAgencyOptions()}
          showSearchBar={true}
          class={`w-80 text-sm ${props.class ?? ""}`}
          containerClass="w-full"
        />
      </div>
    </Show>
  );
};
